import { Injectable } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';

import { TsSnackbarComponent, DEFAULT_CONFIG, TsSnackbarData, panelClasses } from '../ts-snackbar';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TsSnackbarService {
  private snackBarRef: MatSnackBarRef<TsSnackbarComponent>;
  constructor(private readonly snackBar: MatSnackBar) {}

  public open(
    message: string,
    type: panelClasses = 'info',
    action: string = null,
    config: MatSnackBarConfig = DEFAULT_CONFIG,
  ): MatSnackBarRef<TsSnackbarComponent> {
    this.snackBarRef = this.snackBar.openFromComponent(TsSnackbarComponent, {
      data: {
        message,
        actionText: action,
        type,
      } as TsSnackbarData,
      panelClass: `ts-snackbar__${type}`,
      ...config,
    });

    return this.snackBarRef;
  }

  public openApplyChanges(
    onReset?: () => void,
    onSave?: () => void,
    message = 'Changes were applied to the view',
    data = {
      closeButton: true,
      okLabel: 'Save',
      cancelLabel: 'Reset',
      panelClass: 'ts-snackbar__default',
      flexCol: false,
    },
  ): MatSnackBarRef<TsSnackbarComponent> {
    return this.snackBar.openFromComponent(TsSnackbarComponent, {
      data: {
        ...(data ?? {}),
        message,
        type: 'default',
        actionText: 'confirm-changes',
        onReset,
        onSave,
      } as TsSnackbarData,
      panelClass: data.panelClass,
      ...DEFAULT_CONFIG,
      duration: 0,
    });
  }

  public onAction(): Observable<void> {
    return this.snackBarRef.onAction();
  }

  public dismiss(): void {
    this.snackBar.dismiss();
  }
}
